"use client"

import { useInView } from "react-intersection-observer"
import { useInViewConfig, useTransitionUpStyles } from "ui"
import { StyledContainer } from "./styles"

interface BestInvestClientProps {
  children: React.ReactNode
}

const BestInvestClient = ({ children }: BestInvestClientProps) => {
  const { ref, inView } = useInView(useInViewConfig)
  const transitionStyles = useTransitionUpStyles(inView)

  return (
    <StyledContainer ref={ref} style={transitionStyles}>
      {children}
    </StyledContainer>
  )
}

export default BestInvestClient
